import {
  LIST_EPPS_SIMPLE,
  PAGINACION_EPPS,
  REPORTE_SOLICITUDES_EPP,
  REPORTE_SOLICITUDES_EPP_PRECIOS,
} from "@/apollo/queries/epp";
import { exQue } from "@/utils/gql";
import { fechaConHora, formatDDMMYYY } from "@/utils/time";

// Reportes usa gerencias y epps del store: getGerencias/setGerencias están en
// CentroCosto.js y setEpps en epp.js (aquí había copias que se pisaban).
export const ReportActions = {
  async getAllSimpleEpps({ commit, state, dispatch }) {
    if (state.eppIds && state.eppIds.length) {
      exQue(LIST_EPPS_SIMPLE, {
        ids: state.eppIds,
      }).then((epps) => {
        commit("setEpps", epps);
      });
      return;
    }

    await dispatch("ensureFormEpp");

    exQue(PAGINACION_EPPS, {
      idFormulario: state.formEpp?.id_formulario,
      limite: 200,
    }).then((paginacionEpp) => {
      const ids = paginacionEpp.flatMap((item) => item.epps);
      commit("SET_EPP_IDS", ids);
      exQue(LIST_EPPS_SIMPLE, {
        ids,
      }).then((epps) => {
        commit("setEpps", epps);
      });
    });
  },
  // Devuelve null si la consulta falla y [] si no hay solicitudes
  async getReport(
    { state, dispatch, rootGetters },
    { fecha_inicio, fecha_final, id_gerencia, codigo_producto },
  ) {
    await dispatch("ensureFormEpp");

    // Columnas de sociedad, sucursal y gerencia con los términos de la empresa
    const termino = rootGetters["terminos/termino"];
    const SOCIEDAD = termino("SOCIEDAD");
    const SUCURSAL = termino("SUCURSAL");
    const GERENCIA = termino("GERENCIA");

    return exQue(REPORTE_SOLICITUDES_EPP, {
      id_formulario: state.formEpp?.id_formulario,
      fecha_inicio,
      // El backend compara contra la fecha a las 00:00: sin la hora, el
      // último día del rango queda fuera
      fecha_final: fechaConHora(fecha_final, "23:59:59"),
      id_gerencia,
      codigo_producto,
    })
      .then((response) => {
        return response.flatMap((solicitud) => {
          const respuestas = solicitud?.respuestas?.length
            ? solicitud.respuestas
            : [null];

          // --- CÁLCULOS NUEVOS ---
          const poseeFirma = solicitud?.firma?.document_url ? "Sí" : "No";
          const nombreCompleto = `${solicitud?.usuarios?.primer_nombre || ""} ${
            solicitud?.usuarios?.apellido_paterno || ""
          }`.trim();

          // Cálculo de tiempo de gestión en días (KPI)
          let diasGestion = "";
          if (solicitud?.fecha_creacion && solicitud?.fecha_modificacion) {
            const fCreacion = new Date(solicitud.fecha_creacion);
            const fModificacion = new Date(solicitud.fecha_modificacion);
            const diffTime = Math.abs(fModificacion - fCreacion);
            diasGestion = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
          }

          // Una fila por lote del que se descontó lo entregado; sin lotes (no
          // entregada o empresa sin lotes), una fila por producto
          return respuestas.flatMap((respuesta) => {
            const lotes = respuesta?.lotes?.length ? respuesta.lotes : [null];
            return lotes.map((lote) => ({
              "ID Solicitud": solicitud?.id_solicitud ?? "",
              "Código Solicitud": (solicitud?.codigo_solicitud || "").trim(),
              "Fecha Creación": solicitud?.fecha_creacion
                ? formatDDMMYYY(solicitud.fecha_creacion)
                : "",
              "Fecha Modificación": solicitud?.fecha_modificacion
                ? formatDDMMYYY(solicitud.fecha_modificacion)
                : "",

              // Nuevas columnas de métricas
              "Tiempo de Gestión (Días)": diasGestion,

              Estado: solicitud?.estado_solicitud?.nombre ?? "",
              "ID Estado": solicitud?.estado_solicitud?.id_estado ?? "",
              "ID Usuario": solicitud?.usuarios?.id_usuario ?? "",

              // Nueva columna de Nombre Completo
              "Nombre Completo": nombreCompleto,
              "Nombre Usuario": solicitud?.usuarios?.primer_nombre ?? "",
              "Apellido Usuario": solicitud?.usuarios?.apellido_paterno ?? "",

              "RUT Usuario": solicitud?.usuarios?.rut_usuario
                ? `${solicitud.usuarios.rut_usuario}-${
                    solicitud?.usuarios?.dv_usuario || ""
                  }`
                : "",
              // Sociedad, sucursal y gerencia del solicitante, con los términos
              // de la empresa
              [SOCIEDAD.Singular]:
                solicitud?.usuarios?.sociedad?.nombre_sociedad || `Sin ${SOCIEDAD.singular}`,
              [SUCURSAL.Singular]:
                solicitud?.usuarios?.sucursal?.nombre_sucursal || `Sin ${SUCURSAL.singular}`,
              [GERENCIA.Singular]:
                solicitud?.usuarios?.gerencia?.nombre_gerencia ?? `Sin ${GERENCIA.singular}`,
              OT: solicitud?.ot ?? "",
              "Centro de Costo": solicitud?.centro_costo || "Sin CECO",

              "Firma Fecha": solicitud?.firma?.fecha_fima
                ? formatDDMMYYY(solicitud.firma.fecha_fima)
                : "",

              // Nueva columna de control visual
              "Posee Firma": poseeFirma,
              "Firma Documento": solicitud?.firma?.document_url ?? "",

              // Cantidade solicitada
              "Cantidad Solicitada": respuesta?.cantidad_solicitada ?? "",
              "Cantidad Entregada": respuesta?.cantidad_entregada ?? "",
              
              
              Producto: respuesta?.producto?.nombre ?? "",
              "Código EPP": respuesta?.producto?.sku ?? "",

              // Trazabilidad del descuento de stock
              Bodega: lote?.nombre_bodega || "",
              Lote: lote?.lote_nombre || "",
            }));
          });
        });
      })
      .catch((error) => {
        console.error("Error al obtener el reporte de solicitudes EPP:", error);
        return null;
      });
  },
  // Devuelve null si la consulta falla
  async getReportPrecios(
    { state, dispatch },
    { isEntregadas = true, fechaFinal, fechaInicio },
  ) {
    await dispatch("ensureFormEpp");

    // Si falla, exQue ya deja el error en consola
    return exQue(REPORTE_SOLICITUDES_EPP_PRECIOS, {
      idFormulario: state.formEpp?.id_formulario,
      isEntregadas,
      fechaFinal: fechaConHora(fechaFinal, "23:59:59"),
      fechaInicio,
    }).catch(() => null);
  },
};
